var MDB = window.MDB = window.MDB || {};
MDB.GDPR = MDB.GDPR || {};
MDB.GDPR.Requests = MDB.GDPR.Requests || {};

$.extend(MDB.GDPR.Requests, {
    bootEditor: function(){
        var postedSuppliers = $('#Suppliers');
        var selectedSuppliers = postedSuppliers.val() || [];
        
        //supplier-checkbox
        $('#supplier-selector').on('change', '.supplier-checkbox', function () {
            var id = $(this).data('id');
            var currentIndex = selectedSuppliers.indexOf(id);
            var isCurrentlySelected = currentIndex !== -1;
            
            if (this.checked && !isCurrentlySelected){
                selectedSuppliers.push(id);
            }
            
            if (!this.checked && isCurrentlySelected){
                selectedSuppliers.splice(currentIndex, 1);
            }
        });

        $('#create-request-form').on('submit', function (e) {
            postedSuppliers.val(selectedSuppliers);
        })
    }
});